import { render } from "./InvitationPage.vue?vue&type=template&id=7c8ce64c"
import script from "./InvitationPage.vue?vue&type=script&lang=js"
export * from "./InvitationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__